"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
var lsbDetectPlugin = require("./lsbdetectplug");
var lsbmsg = require("./lsbupdate");
var lsbDetect;
(function () {
    lsbDetect = lsbDetectPlugin.init(function (data) {
        console.log('LSB Detect success');
        console.log(data);
        $('.psp-lsb-detect span:not([class="icon-lsb"])').html(l.Translator.translate('Redirecting'));
        $('.psp-lsb-detect span:not([class="icon-lsb"])').attr('t', 'Redirecting');
        l.Content.queryByKeywordsAsync(data.SN, function (product) {
            if (product && product.length && product.length > 0 && product[0].IsSupported === true && product[0].Name) {
                l.DTM.push({
                    type: "eSupportProcess_Complete",
                    name: "LSB:SuccessfulMachineDetection",
                    action: "Button Click",
                    eSupportDeviceInfo: {
                        serialNumber: data.SN,
                        machineTypeModel: data.MTM
                    }
                });
                l.Redirect.toProductSupportPage(product[0].Id, "", {}, product[0].Serial);
            }
            else {
                console.log('Cannot find product corresponding to SN ' + data.SN);
                lsbmsg.ShowContent(l.Translator.translate('lsb failed to detect'));
                $('.psp-lsb-detect').prop('disabled', false);
                $('.psp-lsb-detect span:not([class="icon-lsb"])').html(l.Translator.translate('Detect my Serial Number'));
                $('.psp-lsb-detect span:not([class="icon-lsb"])').attr('t', 'Detect my Serial Number');
            }
        });
    }, function (isUserCancelled) {
        if (isUserCancelled === true) {
            console.log('LSB Detect user cancelled');
        }
        else {
            console.log('LSB Detect failed');
        }
        $('.psp-lsb-install').prop('disabled', false);
    }, '.psp-lsb-install');
    $('.psp-lsb-detect').on('click', function () {
        $('.psp-lsb-detect').prop('disabled', true);
        lsbDetect.Start();
    });
    $('header').after('<div class="psp-lsb-install"></div>');
})();
